import { render, staticRenderFns } from "./XiaoYouQuan.vue?vue&type=template&id=eedea916&scoped=true"
import script from "./XiaoYouQuan.vue?vue&type=script&lang=js"
export * from "./XiaoYouQuan.vue?vue&type=script&lang=js"
import style0 from "./XiaoYouQuan.vue?vue&type=style&index=0&id=eedea916&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eedea916",
  null
  
)

export default component.exports